import React, { Component } from 'react'
import Select from 'react-select';
import { reduxForm } from 'redux-form';
import { selectors, actions } from '../sagas/reservation/search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextInput } from '../shared/TextInput'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router-dom'
import '../stylesheets/index_search.sass'

class IndexSearch extends Component {

  goToReservation = (event) => {
    this.props.history.push(`/reservations/${event['value']}`)
  }

  render () {
    return (
      <div style={{marginBottom: '30px'}}>
        <Select
          className='reservation-search'
          name="form-field-name"
          style={
            {
              'color': '#333',
              'backgroundColor': '#F9F9F9',
              'outline': 'none',
              'borderColor':'none'
            }
          }
          arrowRenderer={null}
          optionClassName='reservation-search'
          onInputChange={ this.props.searchReservations }
          filterOptions={ () => this.props.orderOptions }
          escapeClearsValue={ false }
          onSelectResetsInput={ false }
          onBlurResetsInput={ false }
          placeholder={ 'Search for Reservation' }
          options={ this.props.orderOptions }
          onChange={ this.goToReservation }
        />
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  orders: selectors.orders(store),
  search: selectors.search(store),
  loaded: selectors.loaded(store),
  orderOptions: selectors.orderOptions(store)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default withRouter(connect(
  mapStateToProps, mapDispatchToProps, null, { pure: false })(
  reduxForm(
  { form: 'reservation_search'}
)(IndexSearch)));



// WEBPACK FOOTER //
// ./src/Reservations/IndexSearch.jsx